import { ApolloClient, InMemoryCache, NormalizedCacheObject } from '@apollo/client';

import { DEV } from 'application/consts';

export const ensureNormalizedCacheObjectClient = (client: ApolloClient<any>): ApolloClient<NormalizedCacheObject> => {
  if (client.cache instanceof InMemoryCache) {
    return client as ApolloClient<NormalizedCacheObject>;
  }

  if (DEV) {
    console.warn('ApolloClient cache is not InMemoryCache, but NormalizedCacheObject is expected');
  }

  return client as unknown as ApolloClient<NormalizedCacheObject>;
};
